// Amount the host receives for a reservation, in the reservation currency. Same rule as the payout cron
// (core/cron/autoPayoutToHost.js): total - hostServiceFee, plus the promo discount when the admin funds it.
export const adminPromoAmount = (reservation) => {
  const discount = Number(reservation?.promoDiscount);
  return reservation?.promoCodeType === 'admin' && discount > 0 ? discount : 0;
};

export const hostPayoutAmount = (reservation) => (
  Number(reservation?.total) + adminPromoAmount(reservation) - Number(reservation?.hostServiceFee)
);

// A FAILED PawaPay payout never reached the host: it is not a payment (PROCESSING and the other statuses still count).
export const isPaidTransaction = (transaction) => Boolean(transaction) && transaction.providerStatus !== 'FAILED';

export const paidHostTransaction = (reservation) => (
  isPaidTransaction(reservation?.hostTransaction) ? reservation.hostTransaction : null
);
